"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserMessage = _interopRequireDefault(require("./UserMessage"));

var _AgentMessage = _interopRequireDefault(require("./AgentMessage"));

var _TypingIndicator = _interopRequireDefault(require("./TypingIndicator"));

var _AIAnswersSkeletonLoader = _interopRequireDefault(require("../SmartSummary/AIAnswersSkeletonLoader"));

var ConversationThread = function ConversationThread(_ref) {
  var turns = _ref.turns,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled,
      onButtonSelect = _ref.onButtonSelect,
      onFormSubmit = _ref.onFormSubmit,
      onFollowUpSelect = _ref.onFollowUpSelect,
      onSourceClick = _ref.onSourceClick,
      onFeedbackVote = _ref.onFeedbackVote;
  var lastAgentIndex = -1;

  for (var i = turns.length - 1; i >= 0; i--) {
    if (turns[i].role === 'agent') {
      lastAgentIndex = i;
      break;
    }
  } // Related Articles only surface on the first answer of the conversation;
  // follow-up replies omit the sources rail. This is the earliest agent turn.


  var firstAgentIndex = -1;

  for (var _i = 0; _i < turns.length; _i++) {
    if (turns[_i].role === 'agent') {
      firstAgentIndex = _i;
      break;
    }
  } // Show the typing indicator only when we're waiting on the agent — i.e. the last
  // turn is the user's. After the agent replies, isLoading flips off and the indicator
  // disappears in place of the real agent bubble.


  var lastTurn = turns.length > 0 ? turns[turns.length - 1] : null;
  var showLoadingIndicator = Boolean(isLoading) && (lastTurn === null || lastTurn.role === 'user'); // First iteration = the initial answer is still generating (no agent turn has
  // arrived yet). There we show the full skeleton loader (text bars + source
  // cards) instead of the small typing bubble; follow-up replies keep the
  // lighter typing bubble since the box is already populated above.

  var isFirstIteration = !turns.some(function (turn) {
    return turn.role === 'agent';
  });
  return (0, _preact.h)("div", {
    className: "forethought-agent__thread"
  }, turns.map(function (turn, index) {
    if (turn.role === 'user') {
      return (0, _preact.h)(_UserMessage.default, {
        key: turn.id,
        content: turn.content
      });
    } // The question this answer responded to — nearest preceding user turn.
    // Passed to the feedback payload as `input` (answer text is `output`).


    var userQuery = '';

    for (var _i2 = index - 1; _i2 >= 0; _i2--) {
      if (turns[_i2].role === 'user') {
        userQuery = turns[_i2].content;
        break;
      }
    }

    return (0, _preact.h)(_AgentMessage.default, {
      key: turn.id,
      turn: turn,
      isLastAgentTurn: index === lastAgentIndex,
      isFirstAgentTurn: index === firstAgentIndex,
      disabled: disabled,
      userQuery: userQuery,
      onButtonSelect: onButtonSelect,
      onFormSubmit: onFormSubmit,
      onFollowUpSelect: onFollowUpSelect,
      onSourceClick: onSourceClick,
      onFeedbackVote: onFeedbackVote
    });
  }), showLoadingIndicator && (isFirstIteration ? (0, _preact.h)(_AIAnswersSkeletonLoader.default, null) : (0, _preact.h)(_TypingIndicator.default, null)));
};

var _default = ConversationThread;
exports.default = _default;